export const bulkImportMenuItems = {
  DOWNLOAD_TEMPLATE: 'Download bulk import template',
  CREATE_SOFT_TAGS: 'Bulk create soft tags',
  BULK_IMPORTS_HISTORY: 'Bulk imports history',
};

export const BULK_IMPORT_MODAL_TITLE = 'Bulk Import Soft Tags';

export const bulkImportActionButtons = {
  UPLOAD_BUTTON_TEXT: 'Upload',
  CANCEL_BUTTON_TEXT: 'Cancel',
  DOWNLOAD_TEMPLATE_BUTTON_TEXT: 'Download Template',
};

export const fileUploadText = {
  MAX_FILE_LIMIT_INFO: 'File quantity: one file per upload ',
  TITLE: 'Drop file here',
  SUBTITLE: 'Supported formats: CSV (Max 50 rows)',
  SELECT_FILE_BUTTON_TEXT: 'Select File',
  MAX_FILE_REACHED_POPOVER_TEXT: 'Max one file can be uploaded at a time',
};

export const fileUploadStatusText = {
  EMPTY_FILE_INFO: 'No file selected',
  CAPTION: 'File',
};

export const fileUploadResult = {
  UPLOAD_SUCCESS: 'Upload successful',
  UPLOAD_FAILED: 'Upload failed',
};

export const bulkImportAlertSuccessText = {
  TITLE: 'Import Has Started',
  DESCRIPTION:
    'The import file was uploaded successfully. The process of creating the upload soft tags has started. It might take some minutes until it is concluded.',
  CHECK_IMPORTS_HISTORY_BUTTON_TEXT: 'Check Imports History',
  CANCEL_BUTTON_TEXT: 'Cancel',
};

export const bulkImportAlertErrorText = {
  TITLE: 'Bulk creation failed',
  DESCRIPTION:
    'Something went wrong with your bulk creation. Please download the CSV, follow the instructions from the error column in it , then try upload again',
  DOWNLOAD_CSV_BUTTON_TEXT: 'Download CSV with errors',
  CANCEL_BUTTON_TEXT: 'Cancel',
};
